module.exports = __webpack_public_path__ + "img/product1.545a94c3.png";